var _circle, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 22,
    fill: "#FAD6D6",
    fillOpacity: 0.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    transform: "translate(12.5 12)",
    fill: "#FAD6D6",
    fillOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2999 20.0118C26.2249 19.8024 26.1725 19.5823 26.1457 19.3543C24.6558 19.179 23.5 17.912 23.5 16.375C23.5 15.7226 23.7083 15.1188 24.0619 14.6265C23.7354 14.625 23.3827 14.625 23 14.625C20.5538 14.625 19.3307 14.625 18.3659 15.0246C17.0795 15.5575 16.0575 16.5795 15.5246 17.8659C15.125 18.8307 15.125 20.0538 15.125 22.5V25.125C15.125 27.5999 15.125 28.8373 15.8938 29.6062C16.6627 30.375 17.9001 30.375 20.375 30.375H23C25.4462 30.375 26.6693 30.375 27.6341 29.9754C28.9205 29.4425 29.9425 28.4205 30.4754 27.1341C30.875 26.1693 30.875 24.9462 30.875 22.5C30.875 22.1173 30.875 21.7646 30.8735 21.4381C30.3812 21.7917 29.7774 22 29.125 22C28.0784 22 27.157 21.4641 26.6203 20.6517C26.6234 20.684 26.625 20.7167 26.625 20.7497C26.625 21.302 26.1773 21.7497 25.625 21.7497H20.375C19.8227 21.7497 19.375 21.302 19.375 20.7497C19.375 20.1974 19.8227 19.7497 20.375 19.7497H25.625C25.8851 19.7497 26.122 19.849 26.2999 20.0118ZM20.375 23.2497C19.8227 23.2497 19.375 23.6974 19.375 24.2497C19.375 24.802 19.8227 25.2497 20.375 25.2497H23C23.5523 25.2497 24 24.802 24 24.2497C24 23.6974 23.5523 23.2497 23 23.2497H20.375Z",
    fill: "#760000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 19L29.125 13.75M26.5 16.375H31.75",
    stroke: "#760000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.58e6b4b1e469019554060790bcf4282f.svg";
export { ForwardRef as ReactComponent };